export default class ExcelImportError extends Error {
    constructor(msg) {
        super();
        this.msg = msg;
    }
}
